<template>
  <div class="page1">
    <div class="logo-box" style="display: none;">

      <!-- <img src="../assets/logo.png" class="logo"> -->
      <!-- <div style="color: #fff;font-size: 26px;">巨蟹金分期管理</div> -->
      <div style="color: #fff;font-size: 26px;">{{ $store.state.systemtitle }}</div>
      <div class="icon-box" style="margin-left: auto;">
        <theme></theme>
      </div>
      <div class="icon-box">
        <i class="el-icon-full-screen" @click="screen"></i>
      </div>
      <div class="icon-box">
        <i class="el-icon-refresh-right" @click="$router.go(0)"></i>
      </div>
      <el-dropdown @command="handleCommand">
				<span class="el-dropdown-link" style="color: #fff;">
<!--					{{ admin.user_name }}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
				</span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="5">修改密码</el-dropdown-item> -->
          <el-dropdown-item command='2'>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-container>
      <leftNav></leftNav>
      <el-container>
        <!-- <div class="topnav">
          <div class="icon-box">
            <img src="../assets/imgs/quanping.png" class="navico" @click="screen"/>
          </div>
          <div class="icon-box">
            <img src="../assets/imgs/sx1.png" class="navico" @click="$router.go(0)"/>

          </div>
          <div class="icon-box">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="color: #333;">
              {{ admin.user_name }}<img src="../assets/imgs/dl.png" class="navico" />
            </span>

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item command='2'>退出登录</el-dropdown-item>
            </el-dropdown-menu>

          </el-dropdown>
          </div>

        </div> -->

        <el-header>
          <headers></headers>
        </el-header>
        <el-main>

          <div style="display: flex;align-items: center;font-size: 14px;margin-bottom: 10px;color: #333;">
            <img src="../assets/imgs/shouyeicon.png" class="navico" v-if="routeArr.length>1"/>
            <el-breadcrumb separator-class="el-icon-arrow-right" v-if="routeArr != ''">
              <el-breadcrumb-item v-for="item in routeArr" :key="item.path"
                                  v-if="routeArr.length>1">{{ item.name }}
              </el-breadcrumb-item>

            </el-breadcrumb>


            <!-- yiweirouteList -->
            <!-- <div v-if>
              当前位置：
            </div> -->
          </div>

          <transition name="slide-fade">
            <router-view></router-view>
          </transition>
        </el-main>
      </el-container>
    </el-container>

    <el-dialog title="修改密码" :visible.sync="pwdshow" width="350px">
      <el-form label-width="90px" label-position="left">
        <el-form-item label="原密码: " prop="kdmc">
          <el-input v-model="pwdform.oldpassword" show-password placeholder="请输入原密码">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码: " prop="kdmc">
          <el-input v-model="pwdform.newpassword" show-password placeholder="请输入新密码">
          </el-input>
        </el-form-item>
        <el-form-item label="重复新密码: " prop="kdmc">
          <el-input v-model="pwdform.renewpassword" show-password placeholder="请重复新密码">
          </el-input>
        </el-form-item>

      </el-form>
      <div style="text-align: center;">
        <el-button type="warning" @click="changepwd">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import theme from '@/components/theme.vue'
import leftNav from '@/components/leftNav.vue'
import headers from '@/components/header.vue'

export default {
  data() {
    return {
      fullscreen: false,
      admin: JSON.parse(sessionStorage.getItem('admin_user')),
      password: '',
      num: 0,
      money: 1,
      tixianshow: false,
      name: '',
      avatar: '',
      nameshow: false,
      pwdform: {
        oldpassword: '',
        newpassword: '',
        renewpassword: ''
      },
      pwdshow: false
    }
  },
  components: {
    leftNav,
    headers,
    theme
  },
  created() {
    this.$store.commit('putrouteArr')
    this.admin = JSON.parse(sessionStorage.getItem('admin_main_admin'))
    // 获取系统配置
  },
  // watch: {
  // 	'$route.path'() {
  // 		console.log(this.$route, )

  // 	}
  // },
  computed: {
    routeArr() {
      console.log(111, this.$route.path)
      let arr = []
      console.log(11, this.$store.state.routeNav)
      this.$store.state.routeNav.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.children.forEach(it => {
            if (it.path == this.$route.path) {
              arr = [{
                name: item.name,
                path: ''
              }, {
                name: it.name,
                path: it.path
              },]
            }
          })
        } else {
          arr = [{
            name: item.name,
            path: ''
          }]
        }
      })
      console.log('arr', arr)
      if (arr.length == 1) {
        console.log('this.$store.state.yiweirouteList', this.$store.state.yiweirouteList)
        let ywXunhuan = this.$store.state.yiweirouteList
        for (let xinxi in ywXunhuan) {
          if (ywXunhuan[xinxi].path == this.$route.path) {
            console.log('ywXunhuan[xinxi]', ywXunhuan[xinxi])
          }
        }
      }


      return arr
    },
    isCollapse() {
      return this.$store.state.leftnav.isCollapse
    },
    // routeArr() {
    // 	return this.$store.state.routeArr
    // },
    thispath: {
      get() {
        return this.$store.state.thispath
      },
      set(value) {

      }

    },
  },
  methods: {
    chengleft(val) {
      this.$store.commit('chengleft', val)
    },
    getImg(val) {
      this.admin.avatar = val
    },
    screen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    delpath(path) {

      this.$store.commit('delpath', path)
    },
    getimg(url) {
      this.avatar = url
    },
    tabclick(e) {
      console.log(e, 888)
      this.$router.push(e.name)
    },

    async handleCommand(e) {
      if (e == 1) {
        this.$router.push('/shopcenter')
      } else if (e == 2) {
        sessionStorage.removeItem('admin')
        sessionStorage.removeItem('admintoken')
        sessionStorage.removeItem('logo')
        sessionStorage.removeItem('putispermission')
        sessionStorage.removeItem('putispermission')
        sessionStorage.removeItem('routeArr')
        sessionStorage.removeItem('shopId')
        this.$router.push('/')
      } else if (e == 3) {
        let res = await this.$api.balanceGet()
        this.num = this.num = res == '成功' ? 0 : res
        this.tixianshow = true

      } else if (e == 4) {
        this.name = this.shop.name
        this.avatar = this.shop.avatar
        this.nameshow = true
      } else if (e == 5) {
        this.pwdform = {
          oldpassword: '',
          newpassword: '',
          renewpassword: ''
        }
        this.pwdshow = true
      }
    },
    async shopnameupdate() {
      if (!this.avatar) {
        this.$message.error({
          showClose: true,
          message: '请上传店铺头像'
        })
        return
      }
      if (!this.name) {
        this.$message.error({
          showClose: true,
          message: '请输入新的店铺名称'
        })
        return
      }
      let res = await this.$api.shopnameupdate({
        name: this.name,
        avatar: this.avatar
      })
      if (res) {
        this.shop.name = this.name
        this.shop.avatar = this.avatar
        sessionStorage.setItem('shop', JSON.stringify(this.shop))
        this.nameshow = false
        this.$message.success('修改成功');

      }
    },
    async changepwd() {
      if (!this.pwdform.oldpassword) {
        this.$message.error({
          showClose: true,
          message: '请输入原密码'
        })
        return
      }
      if (!this.pwdform.newpassword) {
        this.$message.error({
          showClose: true,
          message: '请输入新密码'
        })
        return
      }
      if (!this.pwdform.renewpassword) {
        this.$message.error({
          showClose: true,
          message: '请重复输入新密码'
        })
        return
      }
      if (this.pwdform.oldpassword == this.pwdform.newpassword) {
        this.$message.error({
          showClose: true,
          message: '新密码不能与原密码相同'
        })
        return
      }
      if (this.pwdform.newpassword != this.pwdform.renewpassword) {
        this.$message.error({
          showClose: true,
          message: '两次新密码不一致'
        })
        return
      }
      this.$confirm('修改密码后将退出登录，是否确认', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await this.$api.changepwd(this.pwdform)
        if (res) {
          this.nameshow = false
          this.$message.success('修改成功');
          sessionStorage.removeItem('admin')
          sessionStorage.removeItem('admintoken')
          sessionStorage.removeItem('logo')
          sessionStorage.removeItem('putispermission')
          sessionStorage.removeItem('putispermission')
          sessionStorage.removeItem('routeArr')
          sessionStorage.removeItem('shopId')
          this.$router.push('/')
        }
      }).catch(() => {

      });


    },
    tixian() {
      if (this.num * 1 < this.money * 1) {
        this.$message.error({
          showClose: true,
          message: '提现金额不能大于余额'
        })
      } else {
        this.$confirm('是否确认提现' + this.money + '元?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$api.balanceAdd({
            money: this.money
          })
          if (res) {
            this.tixianshow = false
            this.money = 1
            this.$message.success('操作成功');
          }
        }).catch(() => {

        });
      }
    }
  }
}
</script>
<style>

.odbtns .el-button {
  margin-left: 0;
  margin-bottom: 6px;
}

/* .el-table tr{background: #f8f8f8;} */
.el-table td.el-table__cell div {
  color: #666 !important;
}

.el-table th.el-table__cell > .cell {
  font-size: 12px !important;
  color: #333 !important;
}

/* .lft{color: black !important;justify-content: flex-start !important;font-size:14px} */
.order_table_td {
  padding: 10px 0 !important;
}

.el-page-header__content {
  font-size: 14px;
}

.el-table th.el-table__cell > .cell {
  font-size: 13px;
  color: black;
}

.el-breadcrumb__inner {
  color: #333;
}

.el-table td.el-table__cell div {
  font-size: 13px;
  color: #666;
}

.el-dialog__wrapper {
  display: flex;
  align-items: center;
}


.topnav {
  width: 100%;
  background: white;
  height: 60px;
  border: 1px solid #e0e0e0;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.navico {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.formbox {
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 0;
}

.card-title {
  font-size: 15px;
  font-weight: bold;
}

.card-title2 {
  font-size: 14px;
  font-weight: bold;
  padding: 10px 0;
}

.serinp {
  width: 300px;
}

.serinp input {
  background: #F2F3F5;
  border: none;
}

.serbtn {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333;
  height: 32px;
  margin-left: 8px;
  border-radius: 5px;
  padding: 0 18px;
  cursor: pointer;
}

.serbtn.add {
  color: #5B9DFF;
  background-color: #D1E3FF;
}

.serbtn.del {
  color: #FF4036;
  background-color: #FFD8D6;
}

.serbtn.re {
  color: #7DD454;
  background-color: #DDF4D2;
}

.btnico {
  width: 16px;
  height: 16px;
}

.droptext {
  font-size: 12px;
  color: #666;
  height: 30px;
  text-align: center;
}

.droptext:hover {
  color: #1975FF
}

.droptext.bor {
  border-bottom: 1px solid #f0f0f0;
}

.info-row1 {
  width: 100%;
}

.info-t1 {
  font-size: 12px;
  color: #999;
  display: inline-block;
}

.info-t2 {
  font-size: 13px;
  color: #333;
  margin-left: 10px;
}

.info-t3 {
  font-size: 13px;
  color: #333;
  padding-top: 4px;
}

.info-row2 {
  width: 100%;
  display: flex;
  margin-top: 6px;
}

.info-row3 {
  flex: 1;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  height: 80px;
  justify-content: space-between;
}

.info-row4 {
  width: 100%;
  height: 80px;
  margin-top: 6px;
}

.mlab {
  color: white;
  background: #1975FF;
  border-radius: 5px;
  font-size: 11px;
  display: inline-block;
  width: 70px;
  text-align: center;
}

page {
  font-size: 16px;
}

.serbox {
  margin: 20px 0;
}

.sercell {
  display: flex;
  align-items: center;
}

.serlab {
  font-size: 14px;
  color: #555;
  width: 100px;
}

.sercontent {
  flex: 1
}

.sercontent input {
  background: #F2F3F5;
  border: none;
}

.serinp2 input {
  background: #F2F3F5;
  border: none;
}

.serbtn2.re {
  color: #7DD454;
  background-color: #DDF4D2;
}

.serbtn2 {
  display: flex;
  align-items: center;
  font-size: 13px;
  height: 32px;
  margin-left: 8px;
  border-radius: 5px;
  color: #666;
  background: #F2F3F5;
  justify-content: center;
  width: 90px;
}

.serbtn2.on {
  display: flex;
  align-items: center;
  font-size: 13px;
  height: 32px;
  margin-left: 8px;
  border-radius: 5px;
  color: white;
  background: #1975FF;
  justify-content: center;
  width: 90px;
}

.serbtn2.dc {
  display: flex;
  align-items: center;
  font-size: 13px;
  height: 32px;
  margin-left: 8px;
  border-radius: 5px;
  color: white;
  background: #67C23A;
  justify-content: center;
  width: 90px;
}

.btnico2 {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.mbar {
  width: 100%;
  font-size: 13px;
  color: #666;
  display: flex;
  padding: 14px 0;
}

.mtable {
  width: 100%;
}

.width_5 {
  width: 1%;
}

.width_95 {
  width: 99%
}

.width_100 {
  width: 100%
}

.tcell {
  width: 100%;
  display: flex;
}

.tcell.center {
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.tcell2 {
  font-size: 13px;
  color: #444;
  width: 100%;
  padding: 4px 0;
}

.tspan {
  color: #888;
  font-size: 12px;
  margin-right: 10px;
}

.tbox {
  width: 100%;
  margin-bottom: 10px;
  border: 1px solid #f0f0f0;
}

.tbox:hover {
  background: #f8f8f8;
}

.mtr {
  width: 100%;
  display: flex;
}

.tpic {
  width: 60px;
  height: 60px;
  border-radius: 5px;
}

.tcol {
  flex: 1;
  margin-left: 20px;
}

.tlab {
  color: #999;
}

.tcell3 {
  width: 100%;
  display: flex;
  padding: 10px 0;
}

.ttag {
  font-size: 12px;
  border: 1px solid #0065FF;
  color: #0065FF;
  padding: 0 14px;
  border-radius: 5px;
  margin-right: 10px;
  height: 26px;
  display: flex;
  align-items: center;
}

.ttag.on {
  border: 1px solid #FCBF68;
  color: #FCBF68;
}

.topt {
  height: 26px;
  background: #0065FF;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  border-radius: 5px;
  cursor: pointer;
}

.tico {
  width: 16px;
  height: 16px
}

.thead {
  width: 100%;
  padding: 14px 0;
  display: flex;
  background: #F8F8F8;
}

.tfooter {
  width: 98%;
  margin-left: 1%;
  padding: 10px 0;
  border-top: 1px solid #f0f0f0;
}

.obox {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
  padding: 10px 0
}

.obox2 {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
  padding: 10px 0
}

.ot1 {
  color: #666;
  font-size: 13px;
}

.ot2 {
  color: #888;
  font-size: 13px;
}

.wlbox {
  width: 100%;
  background: #f8f8f8;
  padding: 10px 0;
  margin: 10px 0;
}

.wlcell {
  width: 98%;
  margin-left: 1%;
  padding: 10px 0;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
  display: grid;
}

.wlcell.bor {
  border-bottom: 1px solid #f0f0f0;
}

.wltitle {
  width: 98%;
  margin-left: 1%;
  font-size: 14px;
  color: #333;
  font-weight: bold;
  padding: 10px 0;
}

.wlbtns {
  width: 98%;
  margin-left: 1%;
  padding: 10px 0
}

.ids {
  width: 100%;
  margin: 10px 0;
  display: flex;
}

.ids .idbox {
  width: 10vw;
  height: 6vw;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  flex-direction: column;
}

.preimg {
  width: 100%;
  height: 100%;
}

.updimg {
  width: 5vw;
  height: 3vw;
}

.updtext {
  font-size: 12px;
  color: #777;
  margin-top: 4px;
}

.updarea {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.sico {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.sico2 {
  width: 50px;
}

.mtag {
  color: #333;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.ginp input {
  background: #F2F3F5;
  border: none !important;
  width: 400px;
}

.el-cascader .el-input input {
  background: #F2F3F5;
  border: none;
}

.formbar {
  font-size: 16px;
  color: #666;
  width: 100%;
  display: flex;
  padding: 10px 0;
  align-items: center;
}

.el-upload--picture-card {
  border: none;
  background: #F2F3F5;
  width: 140px;
  height: 140px;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 140px;
  height: 140px;
}

.el-notification {
}

.el-header {
  padding: 0 !important;
  height: auto !important;
}

.el-main {
  height: calc(100vh - 130px);
  background: #F5F5F5;
}
</style>
<style scoped>
.curmb {
  margin-bottom: 10px;
  font-size: 15px;
}

.page1 {
  min-width: 1200px;
  height: 100vh;
  background: #f5f5f5;
}

.logo-box {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  background: #000;
  padding: 0 20px;
  box-sizing: border-box;
  z-index: 999;
}

.logo {
  width: auto;
  height: 50px;
  margin-right: 10px;
  border-radius: 3px;
}

.icon-box {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  font-size: 20px;
  justify-content: center;
  color: #fff;
  cursor: pointer;
}


.avatar {
  margin-right: 10px;
  margin-left: 10px;
  min-width: 50px;

  width: 50px;
  height: 50px;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>
